import axios from 'axios';
import omit from 'lodash/omit';

const getSign = params => axios.post(`/pre_signed_posts`, params);
const upload = (url, params) => {
  return axios.post(url, params, { headers: { 'Authorization': ' ' } });
}

export default async (scope, file, resource_id, fullUrl) => {
  const signParams = {
    resource: {
      content_type: file.type
    },
    scope,
    [scope === 'projects' ? 'project_id' : 'account_id']: resource_id
  };

  const sign = (await getSign(signParams)).data.data;
  const params = omit(sign, 'url');
  const formData = new FormData();

  Object.keys(params).forEach(key => {
    formData.append(key, params[key]);
  });

  formData.append('file', file);

  const response = await upload(sign.url, formData);

  if (fullUrl)
    return response.data.match(/<Location>(.+)<\/Location>/)[1];
  else
    return response.data.match(/<Key>(.+)<\/Key>/)[1];
}


// WEBPACK FOOTER //
// ./src/lib/upload-file.js